export default function schoolInfoReducer(state = {}, resp) {
  return state;
}
